import React, { useState, useEffect } from 'react';

const AboutUs = () => {
  const [formData, setFormData] = useState({
    context1: '',
    context2: '',
    context3: '',
    image: null
  });
  const [preview, setPreview] = useState(null);

  useEffect(() => {
    // Fetch initial data
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await fetch('https://admindashboard.clns.in/api/dash/aboutuspage/');
      const result = await response.json();
      if (result.status && result.data) {
        setFormData({
          context1: result.data.context1 || '',
          context2: result.data.context2 || '',
          context3: result.data.context3 || '',
          image: result.data.image || null
        });
        setPreview(result.data.image);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData(prev => ({
        ...prev,
        image: file
      }));
      
      const reader = new FileReader();
      reader.onload = (e) => setPreview(e.target.result);
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = async () => {
    try {
      const formDataToSend = new FormData();
      formDataToSend.append('context1', formData.context1);
      formDataToSend.append('context2', formData.context2);
      formDataToSend.append('context3', formData.context3);
      if (formData.image instanceof File) {
        formDataToSend.append('image', formData.image);
      }

      const response = await fetch('https://admindashboard.clns.in/api/dash/aboutuspage/', {
        method: 'POST',
        body: formDataToSend,
      });

      const result = await response.json();
      if (result.status) {
        alert('Data saved successfully!');
        fetchData(); // Refresh data after save
      }
    } catch (error) {
      console.error('Error saving data:', error);
      alert('Error saving data');
    }
  };

  const handleReset = () => {
    fetchData();
  };

  const styles = {
    container: {
      maxWidth: '800px',
      margin: '0 auto',
      padding: '20px',
      fontFamily: 'Arial, sans-serif'
    },
    title: {
      fontSize: '24px',
      fontWeight: 'bold',
      marginBottom: '20px'
    },
    inputGroup: {
      marginBottom: '20px'
    },
    input: {
      width: '100%',
      padding: '10px',
      marginTop: '5px',
      border: '1px solid #ccc',
      borderRadius: '4px',
      fontSize: '16px'
    },
    imageSection: {
      textAlign: 'center',
      margin: '40px 0'
    },
    preview: {
      width: '100%',
      maxWidth: '400px',
      marginBottom: '20px'
    },
    uploadButton: {
      display: 'inline-block',
      padding: '10px 20px',
      backgroundColor: '#fff',
      border: '1px solid #ccc',
      borderRadius: '4px',
      cursor: 'pointer',
      marginBottom: '40px'
    },
    buttonContainer: {
      display: 'flex',
      justifyContent: 'center',
      gap: '20px',
      marginTop: '40px'
    },
    resetButton: {
      padding: '10px 30px',
      backgroundColor: '#fff',
      border: '1px solid #ccc',
      borderRadius: '4px',
      cursor: 'pointer'
    },
    saveButton: {
      padding: '10px 30px',
      backgroundColor: '#3366ff',
      color: '#fff',
      border: 'none',
      borderRadius: '4px',
      cursor: 'pointer'
    }
  };

  return (
    <div style={styles.container}>
      <h1 style={styles.title}>Write About us</h1>
      
      <div style={styles.inputGroup}>
        <input
          type="text"
          name="context1"
          value={formData.context1}
          onChange={handleInputChange}
          placeholder="Context 1"
          style={styles.input}
        />
      </div>
      
      <div style={styles.inputGroup}>
        <input
          type="text"
          name="context2"
          value={formData.context2}
          onChange={handleInputChange}
          placeholder="Context 2"
          style={styles.input}
        />
      </div>
      
      <div style={styles.inputGroup}>
        <input
          type="text"
          name="context3"
          value={formData.context3}
          onChange={handleInputChange}
          placeholder="Context 3"
          style={styles.input}
        />
      </div>
      
      <div style={styles.imageSection}>
        {preview && (
          <img 
            src={preview} 
            alt="Preview" 
            style={styles.preview}
          />
        )}
        <label style={styles.uploadButton}>
          Upload Photo
          <input
            type="file"
            accept="image/*"
            onChange={handleImageChange}
            style={{ display: 'none' }}
          />
        </label>
      </div>
      
      <div style={styles.buttonContainer}>
        <button onClick={handleReset} style={styles.resetButton}>Reset</button>
        <button onClick={handleSubmit} style={styles.saveButton}>Save</button>
      </div>
    </div>
  );
};

export default AboutUs;